import { Typography, Box, styled } from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../Shared/styles";

export const ProgressbarContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    width: "100%",
});

export const ProgressbarPartContainer = styled(Box)({
    ":first-of-type": {
        div: {
            borderRadius: "90px 0 0 90px",
            backgroundColor: "var(--community-color-light-steal-blue)",
        },
    },

    ":last-of-type": {
        div: {
            borderRadius: "0 90px 90px 0",
            backgroundColor: "#2A3C52",
            borderRight: "none",
        },
    },
});

export const ProgressbarPartBar = styled(Box)({
    minHeight: "8px",
    borderRight: "2px solid white",
    backgroundColor: "var(--community-color-dark-gray)",
});

export const ProgressbarPartLabel = styled(Typography)({
    marginTop: "8px",
    fontSize: "12px",
    color: "var(--community-color-secondary-text)",
    maxWidth: "100%",
    ...TEXT_ELLIPSIS,
});
